import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { PostQuery } from './Shared';

interface JobFilePopupProps {
    fileId: number;
    fileType: string;
    showModal: boolean;
    hideModal(): void;
    saveModal(): void;
}

const JobFilePopupData = (props: JobFilePopupProps) => {
    const [filename, setFilename] = React.useState("");

    const hideModal = () => {
        setFilename("");
        props.hideModal();
    }

    const saveModal = () => {
        if (!filename || filename == "") {
            toast.error("Please enter a filename!");
        } else {
            saveFilename();
        }
    }

    const saveFilename = async () => {
        var saveData = {
            fileId: props.fileId,
            filename: filename + props.fileType
        };

        var jsonItem = JSON.stringify(saveData);

        const apiUrl = "SaveJobFilename";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Filename has been updated");
                setFilename("");
                props.saveModal();
            }
        }
    }
    
    return (
        <Modal size="sm" show={props.showModal} onHide={hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Update Filename</Modal.Title>
                <button type="button" className="close" onClick={hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <label className="input-group" htmlFor="filename">
                        <span className="label">Filename</span>
                        <input className="input marginRight10" maxLength={200} type="text" id="filename" name="filename" value={filename} onChange={(e) => setFilename(e.target.value)} ></input> {props.fileType}
                    </label>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="popup-button--no" onClick={hideModal}>Cancel</button>
                <button className="popup-button--yes" onClick={saveModal}>Save</button>
            </Modal.Footer>
        </Modal>
    )
}

export default JobFilePopupData;